export enum SurveyDataInstitutionOccupationState {
    UNOCCUPIED = 'UNOCCUPIED',
    PARTIALLY_OCCUPIED = 'PARTIALLY_OCCUPIED',
    OCCUPIED = 'OCCUPIED',
}

export namespace SurveyDataInstitutionOccupationState {
    type Data = { text: string; description: string };

    export const Record: Record<SurveyDataInstitutionOccupationState, Data> = {
        [SurveyDataInstitutionOccupationState.UNOCCUPIED]: {text: 'Unbesetzt', description: 'Dieser Standort hat aktuell keine Lehrkraft.'},
        [SurveyDataInstitutionOccupationState.PARTIALLY_OCCUPIED]: {text: 'Teilweise unbesetzt', description: 'Manche Kurse an diesem Standort haben aktuell keine Lehrkraft.'},
        [SurveyDataInstitutionOccupationState.OCCUPIED]: {text: 'Besetzt', description: 'Alle Kurse an diesem Standort sind aktuell durch eine Lehrkraft abgedeckt.'},
    }
}
